import { Validation } from '@percent/admin-dashboard/api/types'

export const validationOrganisationHasRelationships = (validation?: Validation): boolean =>
  !!validation?.organisation?.relationships?.length
